import base64 from 'base-64';

const getKey = query => base64.encode(JSON.stringify(query));

const getPropertyOfKey = (state, key, property, defaultValue) => {
  if (state[key]) {
    return state[key][property];
  }
  return defaultValue;
};

/**
 * This function produces a combined reducer maintains state of an object paged representation.
 */
const byPage = (OBJECTS = undefined) => {
  if (OBJECTS === undefined) {
    throw new Error('Cannot create reducer, missing arguments');
  }

  return (state = {}, { meta, payload, type }) => {
    let key;
    let query = { page: 1 };

    if (meta) {
      query = meta.query;
      key = getKey(query);
    }

    switch (type) {
      case `FETCH_${OBJECTS}_FULFILLED`: {
        const currentPage = meta.page || 1;
        return {
          ...state,
          [key]: {
            // If append is set we're adding to a list
            pages: {
              ...getPropertyOfKey(state, key, 'pages', {}),
              [currentPage]: (payload.results || []).map(obj => obj.id)
            },
            currentPage,
          },
        };
      }
      case `SET_CURRENT_${OBJECTS}_PAGE`:
        return {
          ...state,
          [key]: {
           pages: getPropertyOfKey(state, key, 'pages', {}),
           currentPage: payload.page
          }
        };
      default:
        return state;
    }
  };
};

export default byPage;

/**
 * Selectors
 */
export const getPages = state => (state ? state.pages : {});

export const getCurrentPage = state => (state ? state.currentPage : 1);

export const checkPageExists = (state, page) => (state.pages && Array.isArray(state.pages[page]));



// WEBPACK FOOTER //
// ./app/src/state/reducers/byPage.js